/* FRONT PAGE SCRIPTS */

jQuery(document).ready(function($) {	
	initPreloaderScreen();
	initSliders();	
	initHellobar();	
	initTwentyTwenty();
	initScrollButton();
	initProceduresSlider();
	jQuery(window).on('resize', function() {
		initProceduresSlider();
	});
});

function initPreloaderScreen() {
	setTimeout(function(){
		jQuery('.home #loader').addClass('animated zoomOut');		
	}, 1000);
	setTimeout(function(){		
		jQuery('.home #loader-wrapper').fadeOut('slow');	
		jQuery('.home .off-canvas-wrapper').css('opacity', 1);
	}, 1550);
	initSubmenus();
}


function initSubmenus() {
	jQuery('.top-bar #menu-topnav-1').css('opacity',1);	
/*	setTimeout(function(){
		jQuery('.top-bar .fixedlogo').css('display','block').addClass('animated fadeInLeft');
	}, 800); */
}

function initProceduresSlider() {
	if(!jQuery(".fp-primary-procedures .fp-primary-procedures-slider").hasClass('swiper')) {
		
		jQuery(".fp-primary-procedures .fp-primary-procedures-slider").addClass('swiper swiper-content-slider');
		jQuery(".fp-primary-procedures .fp-primary-procedures-slider").find(".wp-block-group__inner-container").addClass("swiper-wrapper");
		jQuery(".fp-primary-procedures .fp-primary-procedures-slider").find(".kb-row-layout-wrap").addClass("swiper-slide");
		
		if(jQuery(".fp-primary-procedures .fp-primary-procedures-slider .swiper-controls").length < 1) {
			jQuery(".fp-primary-procedures .fp-primary-procedures-slider").append("<div class='swiper-controls content-controls'></div>");
			// jQuery(".fp-primary-procedures.first .fp-primary-procedures-slider").find(".content-controls").append("<div class='swiper-scrollbar'></div>");
			jQuery(".fp-primary-procedures .fp-primary-procedures-slider").find(".content-controls").append("<div class='swiper-button-next content-next'></div>");
			jQuery(".fp-primary-procedures .fp-primary-procedures-slider").find(".content-controls").append("<div class='swiper-pagination'></div>");
			jQuery(".fp-primary-procedures .fp-primary-procedures-slider").find(".content-controls").append("<div class='swiper-button-prev content-prev'></div>");
		}
		
	}
	
	const fpProceduresSliderFirst = new Swiper('.fp-primary-procedures .fp-primary-procedures-slider', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		autoHeight: false,
		//slidesPerView: 1,
		slidesPerView: 1,
		initialSlide: 3,
		spaceBetween: 30,
		allowTouchMove: true,
		centeredSlides: true,
		//width: 345,
		breakpoints: {
			641: {
				slidesPerView: 1.5,
				centeredSlides: true,
				allowTouchMove: true,
				//width: 345,
			},
			821: {
				//slidesPerView: 2,
				centeredSlides: true,
				spaceBetween: 35,
				slidesPerView: 'auto',
				width: 284,
				allowTouchMove: false,
				//loop: false,
			},
			1025: {
				//slidesPerView: 3,
				centeredSlides:true,
				spaceBetween: 35,
				slidesPerView: 'auto',
				allowTouchMove: false,
				width: 284,
				//loop: false,
			},
			1601: {
				//slidesPerView: 3,
				centeredSlides:true,
				spaceBetween: 35,
				slidesPerView: 'auto',
				allowTouchMove: false,
				width: 284,
				//loop: false,
			}
		},
		// Navigation arrows
		navigation: {
			nextEl: `.fp-primary-procedures .fp-primary-procedures-slider .content-next`,
			prevEl: `.fp-primary-procedures .fp-primary-procedures-slider .content-prev`,
		},
		//Scrollbar
		// scrollbar: {
		// 	el: `.fp-primary-procedures.first .fp-primary-procedures-slider .swiper-scrollbar`,
		// 	draggable: true,
		//   },
		  pagination: {
			  el: `.fp-primary-procedures .fp-primary-procedures-slider .swiper-pagination`,
			  type: 'bullets',
		},
	})
}


function initSliders(){	
	/* https://swiperjs.com/get-started/  */

	
	// -------------------------------------------------------------------------------------------------------------
	
	// jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider").addClass('swiper swiper-content-slider');
	// jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider").find(".wp-block-group__inner-container").addClass("swiper-wrapper");
	// jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider").find(".kb-row-layout-wrap").addClass("swiper-slide");
	// 
	// if(jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider .swiper-controls").length < 1) {
	// 	jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider").append("<div class='swiper-controls content-controls'></div>");
	// 	jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider").find(".content-controls").append("<div class='swiper-scrollbar'></div>");
	// 	jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider").find(".content-controls").append("<div class='swiper-button-next content-next'></div>");
	// 	jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider").find(".content-controls").append("<div class='swiper-pagination'></div>");
	// 	jQuery(".fp-primary-procedures.second .fp-primary-procedures-slider").find(".content-controls").append("<div class='swiper-button-prev content-prev'></div>");
	// }
	// 
	// 
	// const fpProceduresSliderSecond = new Swiper('.fp-primary-procedures.second .fp-primary-procedures-slider', {
	// 	// Optional parameters
	// 	direction: 'horizontal',
	// 	loop: true,
	// 	autoHeight: false,
	// 	slidesPerView: 1,
	// 	initialSlide: 3,
	// 	spaceBetween: 30,
	// 	allowTouchMove: false,
	// 	centeredSlides:false,
	// 	reverseDirection: true,
	// 	breakpoints: {
	// 		641: {
	// 			slidesPerView: 1.85,
	// 		},
	// 		821: {
	// 			slidesPerView: 2,
	// 			centeredSlides:false,
	// 			spaceBetween: 35,
	// 			loop: false,
	// 		},
	// 		1279: {
	// 			slidesPerView: 3,
	// 			centeredSlides:false,
	// 			spaceBetween: 35,
	// 			loop: false,
	// 		},
	// 		1601: {
	// 			slidesPerView: 3,
	// 			centeredSlides:false,
	// 			spaceBetween: 35,
	// 			loop: false,
	// 		}
	// 	},
	// 	// Navigation arrows
	// 	navigation: {
	// 		nextEl: `.fp-primary-procedures.second .fp-primary-procedures-slider .content-next`,
	// 		prevEl: `.fp-primary-procedures.second .fp-primary-procedures-slider .content-prev`,
	// 	},
	// 	//Scrollbar
	// 	scrollbar: {
	// 		el: `.fp-primary-procedures.second .fp-primary-procedures-slider .swiper-scrollbar`,
	// 		draggable: true,
	// 	  },
	// 	  pagination: {
	// 		  el: `.fp-primary-procedures.second .fp-primary-procedures-slider .swiper-pagination`,
	// 		  type: 'bullets',
	// 	  },
	// })
	
	// -------------------------------------------------------------------------------------------------------------
	
	var swiperCount = 1;
	
	jQuery(".slider-on-mobile").each(function() {
		jQuery(this).addClass(`swiper swiper-mobile-slider-${swiperCount}`);
		jQuery(this).children(".kt-inside-inner-col").addClass("swiper-wrapper");
		jQuery(this).find(".slide").addClass("swiper-slide");
		
		if(jQuery(".slider-on-mobile .swiper-controls").length < 1) {
			jQuery(this).append("<div class='swiper-controls content-controls'></div>");
			jQuery(this).find(".content-controls").append("<div class='swiper-button-prev content-prev'></div>");
			jQuery(this).find(".content-controls").append("<div class='swiper-pagination'></div>");
			jQuery(this).find(".content-controls").append("<div class='swiper-button-next content-next'></div>");
		}
		
		const contentSlider = new Swiper(`.swiper-mobile-slider-${swiperCount}`, {
			// Optional parameters
			direction: 'horizontal',
			loop: false,
			autoHeight: false,
			slidesPerView: 1.2,
			spaceBetween: 20,
			allowTouchMove: true,
			centeredSlides:true,
			breakpoints: {
				641: {
					slidesPerView: 1,
					centeredSlides:false,
				}
			},
			// Navigation arrows
			navigation: {
				nextEl: `.swiper-mobile-slider-${swiperCount} .content-next`,
				prevEl: `.swiper-mobile-slider-${swiperCount} .content-prev`,
			},
	
			  pagination: {
				  el: `.swiper-mobile-slider-${swiperCount} .swiper-pagination`,
				  type: 'bullets',
			  },
		})
	})
	
	// ------------------------------------------------------------------------------------------------------------
	
	jQuery(".fp-reviews-slider").addClass('swiper swiper-content-slider');
	jQuery(".fp-reviews-slider").find(".wp-block-group__inner-container").addClass("swiper-wrapper");
	jQuery(".fp-reviews-slider").find(".kb-row-layout-wrap").addClass("swiper-slide");
	
	const fpReviewsSlider = new Swiper('.fp-reviews-slider', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		autoHeight: false,
		slidesPerView: 1,
		spaceBetween: 30,
		allowTouchMove: true,
		centeredSlides:true,
		speed: 4000,
		autoplay: {
		   delay: 0,
		},
		
		breakpoints: {
			641: {
				slidesPerView: 1.85,
				allowTouchMove: false,
				autoplay: false,
				spaceBetween: 30,
				centeredSlides: false,
			},
			821: {
				slidesPerView: 2,
				centeredSlides:true,
				spaceBetween: 35,
				loop: true,
				allowTouchMove: false,
				autoplay: false,
				centeredSlides: false,
				spaceBetween: 30,
			},
			1279: {
				slidesPerView: 2.5,
				centeredSlides:true,
				spaceBetween: 60,
				loop: true,
				allowTouchMove: false,
				centeredSlides: false,
				autoplay: false,
				spaceBetween: 30,
			}
		},
	})
	
	// ------------------------------------------------------------------------------------------------------------
	
	jQuery(".fp-results-slider-thumbs").addClass('swiper swiper-content-slider');
	jQuery(".fp-results-slider-thumbs").children(".kt-inside-inner-col").addClass("swiper-wrapper");
	jQuery(".fp-results-slider-thumbs").children(".kt-inside-inner-col").children(".wp-block-kadence-image").addClass("swiper-slide");
	
	const fpResultsThumbsSlider = new Swiper('.fp-results-slider-thumbs', {
		// spaceBetween: 0,
		// slidesPerView: 2,
		// autoplay: false,
		// preventInteractionOnTransition: true,
		// freeMode: true,
		// watchSlidesProgress: true,
		// slideToClickedSlide: true,
		// allowTouchMove: false,
		// centeredSlides: false,
		// threshold: 20
		direction: 'horizontal',
		
		loop: false,
		
		spaceBetween: 10,
		
		slidesPerView: 2,
		
		freeMode: true,
		
		watchSlidesProgress: true,
		
		slideToClickedSlide: true, // Enable this option to update thumbs when clicked
		
		threshold: 10, // Adjust the threshold value as needed
	})
	
	jQuery(".fp-results-slider").addClass('swiper swiper-content-slider');
	jQuery(".fp-results-slider").children(".kt-inside-inner-col").addClass("swiper-wrapper");
	jQuery(".fp-results-slider").children(".kt-inside-inner-col").children(".kb-row-layout-wrap").addClass("swiper-slide");
	
	const fpResultsSlider = new Swiper('.fp-results-slider', {
		// Optional parameters
		direction: 'horizontal',
		loop: true,
		autoHeight: false,
		slidesPerView: 1,
		autoplay: false,
		spaceBetween: 30,
		allowTouchMove: false,
		centeredSlides:false,
		effect: 'fade',
		//preventInteractionOnTransition: true,
		threshold: 10,
		fadeEffect: {
			crossFade: true
		},
		thumbs: {
			swiper: fpResultsThumbsSlider,
		},
	})
	
	//Fix for mobile slider not getting active class
	jQuery(".fp-results-slider-thumbs").find("figure.swiper-slide:nth-of-type(2)").on('click', function() {
		jQuery(".fp-results-slider").find(".swiper-slide:nth-of-type(1)").addClass("swiper-slide-active");
	})
	
	jQuery(".fp-results-slider-thumbs").find("figure.swiper-slide:nth-of-type(1)").on('click', function() {
		jQuery(".fp-results-slider").find(".swiper-slide:nth-of-type(1)").removeClass("swiper-slide-active");
	})
	
	
	
	// ------------------------------------------------------------------------------------------------------------
	
}	

function initHellobar(){
	var helloBarContainer = jQuery('#hello-bar-main');
	if(helloBarContainer.length){
		jQuery('#hello-bar-close-btn').click(function() {
		 helloBarContainer.animate({
			  maxHeight: '0',
			  opacity: '0',
			  padding: '0',
			});
		 helloBarContainer.addClass('hidden');
		});	
	}
}

// VIDEO FOR FRONT PAGE
function initHpVideo() {		
			var isTouchDevice = /Windows Phone/.test(navigator.userAgent) || ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;
		
	jQuery('.banner-wrapper .video').each(function() {
		var holder = jQuery(this);
		var video = holder.find('video');
		var isDesktop = jQuery(document).width() < 1025 ? true : false; 
		
		if (isTouchDevice && isDesktop) {
			video.remove();
			jQuery(".banner-wrapper .video").addClass("mobile");
			jQuery(".banner-wrapper .video").removeClass("desktop");
		} else {
			jQuery(".banner-wrapper .video").addClass("desktop");
		}
	});
}

function initTwentyTwenty() {
	jQuery(".twenty-twenty-container").each(function() {
		jQuery(this).twentytwenty({
			default_offset_pct: 0.5,
			orientation: 'horizontal',
			before_label: 'Before',
			after_label: 'After',
			no_overlay: false,
			move_slider_on_hover: false,
			move_with_handle_only: true,
			click_to_move: false
		});
	}) 
}

function initScrollButton() {
	jQuery('.scroll-button').on('click', function() {
		let nextSection = jQuery(this).closest('.fp-banner').next();
		jQuery('html, body').animate({scrollTop: nextSection.offset().top}, 'slow');
	})
	
	jQuery(".footer .is-style-round-scroll-button .wp-block-button__link").wrapInner("<span></span>");
}